import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { useContext, useState } from 'react';

import { ChatButton } from './ChatButton';
import { ChatDialog } from './ChatWindow';

export const Chat: React.FC = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(false);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <>
      {isOpen && <ChatDialog onClose={() => setIsOpen(false)} />}
      <ChatButton isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />
    </>
  );
};
